// You can adjust these types as needed for your table implementation
interface U2000StringArrayDisplayProps {
  column: unknown; // Replace with actual column type if available
  value: string[] | string;
  row: unknown; // Replace with actual row type if available
}

export const U2000StringArrayDisplay = ({ value }: U2000StringArrayDisplayProps) => {
  // Affiche les éléments du tableau value (ex: calye) séparés par une virgule (en dehors du background), alignés à gauche, avec alternance de bleu pâle et rouge pâle
  return (
    <div className="flex h-full items-center justify-start gap-1">
      {Array.isArray(value)
        ? value.map((str, idx) => (
            <span key={`item-${idx}`} className="flex items-center">
              <span className={idx % 2 === 0 ? "rounded-sm bg-blue-100 px-1 text-blue-800" : "rounded-sm bg-red-100 px-1 text-red-800"}>{str}</span>
              {idx < value.length - 1 && <span className="text-gray-500 mx-1">|</span>}
            </span>
          ))
        : value}
    </div>
  );
};
